import { Component, OnInit, inject } from '@angular/core'
import { toObservable } from '@angular/core/rxjs-interop'
import { filter, take } from 'rxjs/operators'

import { Enums } from '@cyborg-monorepo/hunter/common'

import { SessionService, NavigationService } from '@hunt/services'

@Component({
  selector: 'app-hunt-redirect',
  template: '', // no visible UI
})
export class HuntRedirectComponent implements OnInit {
  private readonly session = inject(SessionService)
  private readonly nav = inject(NavigationService)

  // turn loading signal into an Observable<boolean>
  private readonly loading$ = toObservable(this.session.loading)

  ngOnInit(): void {
    const id = this.nav.huntId()
    if (!id) {
      // no :id → back to list immediately
      this.nav.navigateToHuntList()
      return
    }

    // wait until session.loading flips to false
    this.loading$
      .pipe(
        filter((loading) => !loading),
        take(1),
      )
      .subscribe(() => {
        const hunt = this.session.activeHunt()
        if (!hunt) {
          // failed load → back to list
          this.nav.navigateToHuntList()
        } else if (hunt.status === Enums.StatusEnum.TO_DO) {
          // brand-new hunt
          this.nav.navigateToWorkbench()
        } else if (hunt.editing) {
          // in draft editing mode
          this.nav.navigateToEditReport()
        } else {
          // completed → final report
          this.nav.navigateToFinalReport()
        }
      })
  }
}
